import { Features } from "@/components/landing/Features";

export default function FeaturesPage() {
  return (
    <div data-testid="features-page">
      <Features />
    </div>
  );
}
